import { Onboarding, Shared } from "components/workflow/steps";
import { IFeedback, IUser } from "interfaces";

export const Steps = [
  Onboarding.Details.default,
  Onboarding.Preference.default,
  Onboarding.Profile.default,
  Shared.Feedback.default,
  Onboarding.Setup.default
];

export type OnboardingType = { user: IUser, feedback: IFeedback };